export default () => ({
    client: null,
    decoder: null,
    encoder: null,
    // 摇杆
    client_yg:null,
})